<section class="crud-shell">
  <div class="crud-header">
    <h1>{{ config.titulo }}</h1>

    <p-button
      label="Nuevo registro"
      icon="pi pi-plus"
      (click)="abrirNuevo()"
    />
  </div>

  <div class="crud-card">
    <p-table [value]="items" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" responsiveLayout="scroll">
      <ng-template #header><tr><th *ngFor="let column of config.columns; trackBy: trackByLabel" [pSortableColumn]="column.key">{{ column.label }} <p-sort-icon [field]="column.key" /></th><th class="actions-col">Acciones</th></tr></ng-template>
      <ng-template #body let-item><tr><td *ngFor="let column of config.columns"><ng-container [ngSwitch]="column.type"><span *ngSwitchCase="'money'">S/. {{ formatearMoneda(item[column.key]) }}</span><span *ngSwitchDefault>{{ getValorCelda(item, column.key) }}</span></ng-container></td><td class="actions-col"><button type="button" class="icon-action" (click)="editar(item)" title="Editar"><i class="pi pi-pencil"></i></button><button type="button" class="icon-action icon-action--danger" (click)="confirmarEliminar(item)" title="Eliminar"><i class="pi pi-trash"></i></button></td></tr></ng-template>
      <ng-template #emptymessage><tr><td [attr.colspan]="config.columns.length + 1" class="empty-state">No hay registros disponibles.</td></tr></ng-template>
    </p-table>
  </div>
</section>

<p-dialog
  [(visible)]="visibleDialog"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [style]="{ width: '42rem', maxWidth: '96vw' }"
  [header]="tituloDialogo"
>
  <div class="crud-form">
    <div class="crud-form__field" *ngFor="let field of config.fields">
      <label [for]="field.key">{{ field.label }}</label>

      <ng-container [ngSwitch]="field.type">
        <input
          *ngSwitchCase="'text'"
          [id]="field.key"
          pInputText
          [(ngModel)]="registro[field.key]"
          [placeholder]="field.placeholder || field.label"
        />

        <input
          *ngSwitchCase="'number'"
          [id]="field.key"
          pInputText
          type="number"
          [(ngModel)]="registro[field.key]"
          [placeholder]="field.placeholder || field.label"
        />

        <input
          *ngSwitchCase="'decimal'"
          [id]="field.key"
          pInputText
          type="number"
          step="0.01"
          [(ngModel)]="registro[field.key]"
          [placeholder]="field.placeholder || field.label"
        />

        <select
          *ngSwitchCase="'select'"
          [id]="field.key"
          [(ngModel)]="registro[field.key]"
          class="crud-select"
        >
          <option [ngValue]="null">Selecciona una opción</option>
          <option *ngFor="let option of fieldOptions(field)" [ngValue]="option.id">
            {{ option.descripcion }}
          </option>
        </select>

        <label *ngSwitchCase="'checkbox'" class="checkbox-field">
          <input type="checkbox" [(ngModel)]="registro[field.key]" />
          <span>Registro activo</span>
        </label>
      </ng-container>
    </div>
  </div>

  <div class="crud-dialog-actions">
    <p-button
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      (click)="visibleDialog = false"
    />
    <p-button
      label="Guardar"
      icon="pi pi-check"
      [loading]="guardando"
      (click)="guardar()"
    />
  </div>
</p-dialog>
